import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentDetails } from "../../actions/commonActions";
import moment from "moment";
import { setPageTitle } from "../../utils/helper";
import "./paymentHistory.css"

// const MOMENT_FORMAT = "YYYY-MM-DD HH:mm A";
const MOMENT_FORMAT = "MM-DD-YY";
const PaymentHistory = () => {
  const dispatch = useDispatch();
  const { paymentDetails } = useSelector((reduxState) => reduxState.common);

  useEffect(() => {
    let driverId = localStorage.getItem("driver_id");
    getPaymentDetails(dispatch, driverId);
    setPageTitle("Payment Details");
  }, []);

  return (
    <div>
      <div className="text-center mt-3">
        {/* <h3>Payment Details</h3> */}
        {paymentDetails.length > 0 ? (
          <table className="table mt-3 table-striped ">
            {/* <thead>
              <tr>
                <th>Plan name</th>
                <th>Payment date</th>
                <th>Amount</th>
              </tr>
            </thead> */}
            <tbody>
              {paymentDetails.map((payment, i) => (
                <tr key={i}>
                  <td className="row_data_main">
                    <div className="row_data_text">
                      <p className="h4 date">{payment.transaction_date_time &&
                        moment(payment.transaction_date_time).format(
                          MOMENT_FORMAT
                        )}</p>
                      <p className="h4 p_name"> {payment.plan_name} </p>
                      <p className="h4 s_name"> {payment.station_name} </p>
                    </div>
                    <div className="row_data_price">
                      <p className="h5 price"> {payment.total_amount.toFixed(2)} {payment.currency_code} </p>
                    </div>
                  </td>
                  {/* <td>
                    {payment.transaction_date_time &&
                      moment(payment.transaction_date_time).format(
                        MOMENT_FORMAT
                      )}
                  </td>
                  <td>
                    {payment.currency_code} {payment.total_amount}
                    <p>
                      VAT: {payment.currency_code}{" "}
                      {Math.round(payment.vat_amount)}
                    </p>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-history">No Payment history</p>
        )}
      </div>
    </div>
  );
};

export default PaymentHistory;
